<script>
    import { createEventDispatcher, onMount } from "svelte";
    import { fade } from "svelte/transition";
    import { Button } from "sveltestrap";
    import AppAllPresetGlobal from "./AppAllPresetGlobal.svelte";
    import AppIconDraw from "./AppIconDraw.svelte";
    import ImgFullPreview from "./ImgFullPreview.svelte";
    import { getAllPresetGlobaql } from "./db";
    import l from "./utils/locale";
    import { _err, _log } from "./utils/logger";
    import { shareImage } from "./utils/util";

    const dispatch = createEventDispatcher();
    export let images = [];
    let isDropFiles = true;
    let isShowAllPresetGlobal = false;
    let isShowFiles = { value: true };
    let allPresetGlobal
    let mainEl;
    onMount(async () => {
        _log("onMount");
        initDragAndDrop();

    });
    // $: if (isShowFiles.value) {
    //     isDropFiles = true;
    // }
    $: if (!images.length) {
        isDropFiles = true;
    }

    function initDragAndDrop() {
        const elem = mainEl;
        elem.addEventListener("dragenter", (_e) => {
            // Prevent navigation.
            //e.preventDefault();
            elem.classList.add("dragged");
            elem.classList.add("dragged");
            _log("dragenter");
        });
        elem.addEventListener("dragleave", (_e) => {
            // Prevent navigation.
            //e.preventDefault();
            elem.classList.remove("dragged");
            _log("dragleave");
            elem.classList.remove("dragged");
        });
        elem.addEventListener("dragover", (e) => {
            // Prevent navigation.
            e.preventDefault();
            e.dataTransfer.dropEffect = "move";
        });
        elem.addEventListener("drop", (e) => {
            _log("drop");
            // Prevent navigation.
            e.preventDefault();
            // elem.remove();
            elem.classList.remove("dragged");
            const items = e.dataTransfer.items;
            if (!items) return;
            _log("items", items.length);
            const _files = [];
            for (let i = 0; i < items.length; i++) {
                const item = items[i];
                _log("item.kind", item.kind);
                const folder = item.webkitGetAsEntry();
                if (folder && folder.isDirectory) {
                    traverseFileTree(folder);
                } else {
                    const file = item.getAsFile();
                    _files.push(file);
                }
            }
            if (_files.length > 0) {
                dispatch("onFiles", { data: { files: _files, action: "add" } });
                isDropFiles = false;
            }
        });
    }

    async function traverseFileTree(item, path) {
        path = path || "";
        if (item.isFile) {
            // Get file
            item.file(function (file) {
                //_files.push(file);
                _log("file", file);
                dispatch("onFiles", { data: { files: [file], action: "add" } });
            });
        } else if (item.isDirectory) {
            // Get folder contents
            var dirReader = item.createReader();
            dirReader.readEntries(function (entries) {
                for (var i = 0; i < entries.length; i++) {
                    traverseFileTree(entries[i], path + item.name + "/");
                }
            });
        }
    }

    function removeFileHandler(img) {
        dispatch("onFiles", { data: { files: [img], action: "remove" } });
    }

    function filesHandler() {
        const fileInput = document.createElement("input");
        fileInput.setAttribute("type", "file");
        fileInput.setAttribute("accept", "image/*");
        fileInput.setAttribute("multiple", "true");
        fileInput.onchange = () => {
            const _files = [];
            const fileList = fileInput.files;
            if (fileList.length > 0) {
                for (let i = 0; i < fileList.length; i++) {
                    _files.push(fileList[i]);
                }
                if (_files.length > 0) {
                    dispatch("onFiles", {
                        data: { files: _files, action: "add" },
                    });
                    isDropFiles = false;
                }
            }
        };
        fileInput.click();
    }

    let imgFullPreview;
    function showImage(img) {
        imgFullPreview = img;
    }

    function onClickImage() {
        imgFullPreview = "";
    }

    function clearFiles() {
        dispatch("onFiles", {
            data: { files: [], action: "clear" },
        });
        // isDropFiles = true;
    }

    async function applyPreset() {
        try {

            allPresetGlobal = await getAllPresetGlobaql()
            if(allPresetGlobal && allPresetGlobal.length >0){
                isShowAllPresetGlobal = true
            } else {
                const btnApplyPreset = document.querySelector(".btnApplyPreset")
                if(btnApplyPreset) btnApplyPreset.style.display = "none"
            }
        } catch (error) {
            _err(error)
        }

    }

</script>

<div class="btn-flex-sb">
    {#if images.length > 0}
        <Button color="danger" on:click={clearFiles}
            ><svg
                xmlns="http://www.w3.org/2000/svg"
                class="ionicon"
                viewBox="0 0 512 512"
                ><title>{l["clear_all"]}</title><path
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="32"
                    d="M368 368L144 144M368 144L144 368"
                /></svg
            >
            <div>
                {l["clear"]}
            </div>
        </Button>
        {#if images && images.length > 0}
             <Button color="primary" class="btnApplyPreset" on:click={applyPreset}>
                <AppIconDraw name="load-preset" />
                <div>
                    {l["apply_preset"]}
                </div>
            </Button>
        {/if}
        <Button color="success" on:click={filesHandler}
            ><svg
                xmlns="http://www.w3.org/2000/svg"
                class="ionicon"
                viewBox="0 0 512 512"
                ><title>{l["add_more_images"]}</title><path
                    d="M336 336h40a40 40 0 0040-40V88a40 40 0 00-40-40H136a40 40 0 00-40 40v208a40 40 0 0040 40h40"
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="32"
                /><path
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="32"
                    d="M176 240l80-80 80 80M256 464V176"
                /></svg
            >
            <div>
                {l["add"]}
            </div>
        </Button>
    {/if}
</div>

<div class="files-main" bind:this={mainEl} on:click={filesHandler}>
    {#if images.length}
        <div class="app-files" on:click|stopPropagation={() => {}}>
            {#each images as img}
                <div
                    on:click={() => showImage(img)}
                    class="app-file"
                    transition:fade={{ duration: 200 }}
                >
                    <img class="app-file-img noselect" src={img.url} alt="" />
                    <div class="app-file-label noselect">
                        {img.name}
                    </div>
                    <div
                        class="app-file-remove"
                        on:click|stopPropagation={() => removeFileHandler(img)}
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="ionicon"
                            viewBox="0 0 512 512"
                            ><title>{l["remove"]}</title><path
                                fill="none"
                                stroke="currentColor"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="32"
                                d="M400 256H112"
                            /></svg
                        >
                    </div>
                    <div
                    class="app-file-remove app-file-share"
                    on:click|stopPropagation={() => shareImage(img)}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><title>Share Social</title><path d="M384 336a63.78 63.78 0 00-46.12 19.7l-148-83.27a63.85 63.85 0 000-32.86l148-83.27a63.8 63.8 0 10-15.73-27.87l-148 83.27a64 64 0 100 88.6l148 83.27A64 64 0 10384 336z"/></svg>
                </div>
                </div>
            {/each}
        </div>
    {/if}
    {#if isDropFiles && !images.length}
        <div class="drop-info">
            <div class="drop-label">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="ionicon"
                    viewBox="0 0 512 512"
                    ><title>{l["images"]}</title><path
                        fill="#333"
                        stroke="currentColor"
                        d="M376 352H272V198.63l52.69 52.68a16 16 0 0022.62-22.62l-80-80a16 16 0 00-22.62 0l-80 80a16 16 0 0022.62 22.62L240 198.63V352H136a56.06 56.06 0 01-56-56V88a56.06 56.06 0 0156-56h240a56.06 56.06 0 0156 56v208a56.06 56.06 0 01-56 56zM272 464a16 16 0 01-32 0V352h32z"
                    /></svg
                >
                <div class="drop-info-text noselect">
                    {l["drop"]}
                </div>
            </div>
        </div>
    {/if}
</div>
{#if imgFullPreview}
    <ImgFullPreview img={imgFullPreview} on:onClickImage={onClickImage} />
{/if}

{#if isShowAllPresetGlobal}
    <AppAllPresetGlobal
        bind:isShowAllPresetGlobal
        bind:allPresetGlobal
        on:applePreset
    />
{/if}